// extracted by mini-css-extract-plugin
export default {"container":"rewardInfo_container__zNvqz","info":"rewardInfo_info__K9W1r"};